module.exports = __webpack_public_path__ + "img/sled.a4333fca.png";